interface IInfoIcon {
  onClick?: any;
}

export const InfoIcon = ({ onClick }: IInfoIcon) => {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.983 6.583a.778.778 0 1 0 0-1.555.778.778 0 0 0 0 1.555Zm1.684 7.306h-1.111V7.833H8.889a.556.556 0 1 0 0 1.111h.556v4.945H8.332a.555.555 0 1 0 0 1.111h3.334a.556.556 0 1 0 0-1.111Z"
        fill="#FF3D00"
      />
      <path
        d="M10 18.889a8.888 8.888 0 1 1 0-17.777 8.888 8.888 0 0 1 0 17.777Zm0-16.667a7.778 7.778 0 1 0 0 15.556 7.778 7.778 0 0 0 0-15.556Z"
        fill="#FF3D00"
      />
    </svg>
  );
};
